import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 8px;
`;
export const Title = styled.div`
	font-size: 24px;
	font-weight: 600;
	align-items: center;
	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light15};
	color: ${({ theme }) => theme.colors.text.title};
	display: flex;
	justify-content: space-between;
	padding: 16px;
`;
export const TitleInfo = styled.div`
	align-items: center;
	display: flex;
	gap: 8px;

	svg > path {
		fill: ${({ theme }) => theme.colors.text.title};
	}
`;
export const Text = styled.div`
	font-size: 16px;
	font-weight: 400;
	align-items: center;
	color: ${({ theme }) => theme.colors.text.warning};
	display: flex;
	gap: 10px;

	svg > path {
		fill: ${({ theme }) => theme.colors.text.warning};
	}
`;
export const InputWrapper = styled.div`
	color: #e0e0e0;
	font-size: 16px;
	font-weight: 400;
	font-style: normal;
	margin-top: 20px;
`;
export const Subtitle = styled.div`
	margin-bottom: 12px;
`;

export const Instructions = styled.div`
	font-size: 13px;
	font-weight: 600;

	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	cursor: pointer;
	margin-top: 16px;
`;

export const Success = styled.div`
	font-size: 20px;
	font-weight: 400;
	font-style: normal;
	color: ${({ theme }) => theme.colors.text.subtitle};
	padding: 16px;
`;
export const Attached = styled.div`
	align-items: center;
	display: flex;
	gap: 4px;
	font-size: 16px;
	font-weight: 400;
`;
export const LinkWrapper = styled.div`
	font-size: 16px;
	font-weight: 400;
	font-style: normal;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	margin-top: 20px;
`;
export const LinkStyled = styled.div`
	background-color: ${({ theme }) => theme.colors.transparent.light10};
	border: 1px solid ${({ theme }) => theme.colors.transparent.light60};
	border-radius: 11px;
	color: #ffffff;
	margin-top: 12px;
	padding: 18px 12px;
	word-wrap: break-word;
`;

export const Buttons = styled.div`
	display: flex;
	gap: 12px;
	margin-top: 20px;
`;

export const Error = styled.div`
	border: 1px solid ${({ theme }) => theme.colors.text.error};
`;
export const Main = styled.div`
	padding: 16px;
`;
